import {
    faUsers, faIdBadge, faGraduationCap, faUmbrellaBeach,
    faClipboardCheck, faUserPlus, faMoneyCheckAlt, faFileContract,
} from '@fortawesome/free-solid-svg-icons';

export const HR_NAV = [
    { to: '/hr', label: 'People Directory', icon: faUsers, end: true },
    { to: '/hr/credentialing', label: 'Credentialing & Licences', icon: faIdBadge },
    { to: '/hr/training', label: 'Training & CPD', icon: faGraduationCap },
    { to: '/hr/leave', label: 'Leave & Cover', icon: faUmbrellaBeach },
    { to: '/hr/reviews', label: 'Performance', icon: faClipboardCheck },
    { to: '/hr/recruitment', label: 'Recruitment', icon: faUserPlus },
    { to: '/hr/payroll', label: 'Payroll Interface', icon: faMoneyCheckAlt },
    { to: '/hr/policies', label: 'Policy Attestation', icon: faFileContract },
];

export const LEAVE_COLORS: Record<string, string> = {
    pending: 'warning', approved: 'success', declined: 'danger', cancelled: 'secondary',
};

export const TRAINING_COLORS: Record<string, string> = {
    assigned: 'secondary', in_progress: 'info', completed: 'success', expired: 'danger',
};

export const ROLE_STAGE_COLORS: Record<string, string> = {
    open: 'primary', screening: 'info', interviewing: 'warning',
    offer: 'success', filled: 'success', closed: 'secondary',
};
